import { useQuery } from 'react-query';
import { USER_QUERY_KEY, IS_ADMIN_QUERY_KEY } from './query-keys';
import axios, { AxiosError } from 'libs/axios';

export const useUser = () =>
    useQuery<string, AxiosError>(
        [USER_QUERY_KEY],
        async () => {
            const response = await axios.get<string>('/api/ui/auth/whoami');

            return response.data;
        },
        {
            refetchOnWindowFocus: false
        }
    );

export const useIsAdmin = () =>
    useQuery<boolean, AxiosError>(
        [IS_ADMIN_QUERY_KEY],
        async () => {
            const response = await axios.get<boolean>('/api/ui/auth/isAdmin');

            return response.data;
        },
        {
            refetchOnWindowFocus: false
        }
    );
